export default "__VITE_ASSET__cae70f03__"